@if (conversationType) {
  <div
    flex
    layout="row">
    <mat-icon [matTooltip]="conversationType | conversationTypesTranslation | translate"
      matTooltipPosition="above"
      class="font-size-21"
      [ngStyle]="{'color': contactTypeIconMap[conversationType.name]?.color }"
      [ngStyle]="{'font-size': 21}">
      {{ contactTypeIconMap[conversationType.name]?.icon }}
    </mat-icon>
    @if (contactedPhone) {
      <span>&nbsp;{{contactedPhone}}</span>
    }
    @if (!contactedPhone) {
      <span>&nbsp;{{'communication.hiddenNumber' | translate
      }}</span>
    }
  </div>
}
